import React from 'react';

const ResultsSummary = ({ 
  count, 
  itemType, 
  isLoading, 
  viewMode 
}) => {
  if (isLoading) {
    return (
      <div className="mb-4 text-sm text-gray-600">
        Loading...
      </div>
    );
  }

  const itemLabel = count === 1 ? itemType : `${itemType}s`;
  const viewLabel = viewMode === 'grid' ? 'grid' : 'list';

  return (
    <div className="mb-4 flex items-center justify-between text-sm text-gray-600">
      <span>
        {count} {itemLabel} found
      </span>
      {count > 0 && (
        <span>
          Showing {viewLabel} view
        </span>
      )}
    </div>
  );
};

export default ResultsSummary;
